module.exports = __webpack_public_path__ + "static/media/base.ae24270c.jpg";